import React, { useEffect, useState } from "react";
import "./Cart_Products.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Cart_Products_card from "./cart_Products_card/Cart_Products_card";
import May_you_like_also from "./may_you_like_also/May_you_like_also";
import Back_text_holder from "../common-components/back_text_holder/Back_text_holder";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import GreenStrip from "../common-components/common_green_strip/GreenStrip.js";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import { useSearchParams } from "react-router-dom";
import { encodeId, RolesIds } from "../../utils/common";
import Order_summery_holder from "./may_you_like_also/order_summery_holder/Order_summery_holder.js";
import Order_summery_holder2 from "./may_you_like_also/order_summery_holder2/Order_Summery_Holder2.js";

function Cart_Products() {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("product_id");

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    // {
    //   label: "Product",
    //   link: `/product-details/${encodeId(productId)}`,
    //   isActive: false,
    // },
    { label: "Cart Products", link: "", isActive: true },
  ];

  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const allcartData = useSelector((state) => state.cart.allCarts);

  const user = useSelector((state) => state.myaccount.addMyaccount);
  const isVendor =
    user?.role_id && Number(user?.role_id) === Number(RolesIds.Vendor);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const [instock, setInstock] = useState(false);
  return (
    <>
      <section className="Cart_Products">
        <GreenStrip heading="Cart" />

        <div className="container">
          <Cart_Products_card
            instock={instock}
            setInstock={setInstock}
            data={allcartData}
            isVendor={isVendor}
          />
          <div className="order_summay_div">
            <Order_summery_holder2
              instock={instock}
              data={allcartData}
              isVendor={isVendor}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Cart_Products;
